import workFlowStatesListRedux from '../../views/list/redux/slice';
 import globalWorkflowStepsEditRedux from '../../modals/editStepForm/redux/slice'


//export redux objects

export default {
    workFlowStatesListRedux,
    globalWorkflowStepsEditRedux
}